import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { APIRequestStatus } from "common-ts/dist/models/APIRequestStatus";
import { ServiceTicketListState } from "common-ts/dist/models/ServiceTicket";

const initialState : ServiceTicketListState = {
    serviceTicketList: [],

    productionMetricsList: [],

    status: APIRequestStatus.Idle,
    error: null
}

export const fetchServiceTicketList = createAsyncThunk('serviceTicketList/fetchServiceTicketList', async (arg: string) => {
    const reqBody: any = {
        method: 'get',
        url: 'https://8mav2hp6ki.execute-api.ap-southeast-1.amazonaws.com/OrderAPIProduction/service-ticket',
    };

    // When a courierOrderId is passed, the backend pulls the latest awb for that pickup
    // from KiriminAja and writes it onto the ticket before returning the refreshed list.
    if (arg) {
        reqBody.params = {
            "courierorder": arg
        };
    }

    const response = await axios(reqBody);
    return response.data
})

export const serviceTicketSlice = createSlice({
    name: 'serviceTicketList',
    initialState,
    reducers: {
    },
    extraReducers(builder) {
      builder
        .addCase(fetchServiceTicketList.pending, (state, action) => {
            state.status = APIRequestStatus.RequestInProgress;
        })
        .addCase(fetchServiceTicketList.fulfilled, (state, action) => {
            state.serviceTicketList = action.payload.ticketList;

            state.productionMetricsList = action.payload.productionMetricsList.reverse();

            state.status = APIRequestStatus.Success;
        })
        .addCase(fetchServiceTicketList.rejected, (state, action) => {
            state.status = APIRequestStatus.Failure;
            // state.error = action.error.message
            console.log("fetch is failure");
        })
    }
})

export default serviceTicketSlice.reducer